import {CompanyType} from "@/helpers/constants";
import IFormModel from "@/models/IFormModel";
import CompanyRules from "@/models/company/CompanyRules";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class CompanyCreate implements IFormModel {

	public type: CompanyType | null = null;
	public name: string | null = null;

	public reset(): void {
		this.type = null;
		this.name = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'type':
				return CompanyRules.typeRules;
			case 'name':
				return CompanyRules.nameRules;
			default:
				return [];
		}
	}

}
